import { Route, Routes } from "react-router-dom";
import Userlayout from "../layout/Userlayout";
import AddAddOnPage from "../pages/product/AddAddOnPage";
import AddCouponPage from "../pages/product/AddCouponPage";
import AddCustomerPage from "../pages/AddCustomerPage";
import AddInvoicePage from "../pages/invoice_page/AddInvoicePage";
import AddProductPlanPage from "../pages/product/AddProductPlanPage";
import AddSubscriptionPage from "../pages/subscription_page/AddSubscriptionPage";
import CustomerDetailsPage from "../pages/customer-page/CustomerDetailsPage";
import CustomersPage from "../pages/customer-page/CustomersPage";

import InvoiceDetailsPage from "../pages/invoice_page/InvoiceDetailsPage";
import NotFoundPage from "../pages/NotFoundPage";
import ProductPage from "../pages/product/ProductPage";
import SubscriptionDashboard from "../pages/subscription_page/SubscriptionDashboard";
import SubscriptionDetailsPage from "../pages/subscription_page/SubscriptionDetailsPage";
import SubscriptionPage from "../pages/subscription_page/SubscriptionPage";
import { PrivateRoute } from "./PrivateRoutes";
import PaymentReceivedPage from "../pages/payment_receive/PaymentReceivedPage";

import PaymentReceivedDetailsPage from "../pages/payment_receive/PaymentReceivedDetailsPage";
import InvoicePage from "../pages/invoice_page/InvoicePage";
import SalesOrderPage from "../pages/sales_order/SalesOrderPage";
import AddSalesOrderPage from "../pages/sales_order/AddSalesOrderPage";
import SalesOrderDetailsPage from "../pages/sales_order/SalesOrderDetailsPage";
import CorporatePage from "../pages/corprate_page/CorporatePage";
import CorporateDetailsPage from "../pages/corprate_page/CorporateDetailsPage";
import AddCorporatePage from "../pages/corprate_page/AddCorporatePage";
import CustomerApprovalPage from "../pages/customer_approval/customerApprovalPage";
import CustomerApproveDetails from "../pages/customer_approval/customerApprovedetails";
import VoucherCorporateMainPage from "../pages/vouchers-corporate/VoucherCorporateMainPage";
import AddCorporateVoucherPage from "../pages/vouchers-corporate/AddCorporateVoucherPage";
import VoucherCorDetailsPage from "../pages/vouchers-corporate/VoucherCorDetailsPage";
import VoucherOfflinePage from "../pages/voucher-offline/VoucherOfflinePage";
import OfflineVoucherRedeem from "../pages/voucher-offline/OfflineVoucherRedeem";
import OfflineDetailsPage from "../pages/voucher-offline/OfflneDetailsPage";
import CorporateApprovalPage from "../pages/corporate_approval/CorporateApprovalPage";
import CorporateAppDetailsPage from "../pages/corporate_approval/CorperateAppDetailsPage";
import RatingMainPage from "../pages/rating/RatingMainPage";
import RatingDetailsPage from "../pages/rating/RatingDetailsPage";
import RewardCenterSetup from "../pages/reward_center/setup/RewardCenterSetup";
import RewardEarnPage from "../pages/reward_history/RewardEarnPage";
import RewardHistoryDetails from "../pages/reward_history/RewardHistorydetails";
import RewardRedeemPage from "../pages/reward_redeeem/RewardRedeemPage";
import CarrierBagPage from "../pages/carreer_bag/CarrierBagPage";
import CarrierDetailsPage from "../pages/carreer_bag/CarrierPageDetails";
import CarrierBagAddNewPage from "../pages/carreer_bag/CarrierBadAddNewPage";
import VouchersMainPage from "../pages/vouchers/VoucherMainPage";
import HomePageFeatureDetail from "../pages/home_page_feature/HomePageFeatureDetails";
import VoucherDetailContent from "../pages/vouchers/VoucherDetailsContent";
import VoucherDetailsPage from "../pages/vouchers/VoucherDetailPage";
import CreditNoteMainPage from "../pages/credit_note/CreditNoteMainPage";
import HomePageFeaturePage from "../pages/home_page_feature/HomePageFeaturePage";
import AddHomePageFeature from "../pages/home_page_feature/AddHomePageFeature";
import ItemGroupPage from "../pages/item_group/ItemGroupPage";
import AddItemGroup from "../pages/item_group/AddItemGroup";
import ItemGroupDetailsPage from "../pages/item_group/ItemGroupDetailsPage";
import ItemDetailsPage from "../pages/item-page/ItemDetailsPage";
import AddItemPage from "../pages/item-page/AddItemPage";
import ItemPage from "../pages/item-page/ItemPage";
import PriceListPage from "../pages/price_list/PriceListPage";
import PriceListDetailsPage from "../pages/price_list/PriceListDetailsPage";
import CreditScoreMainPage from "../pages/credit_score/CreditScoreMainPage";
import CreditScoreDetailsPage from "../pages/credit_score/CreditScoreDetailsPage";
import CreditNoteDetailsPage from "../pages/credit_note/CreditNoteDetailsPage";
import CreditNoteAddNew from "../pages/credit_note/CreditNoteAddNew";
import ProductFeaturePage from "../pages/product_feature/ProductFeaturePage";
import AddProductFeature from "../pages/product_feature/AddProductFeature";
import ProductFeatureDetail from "../pages/product_feature/ProductFeatureDetail";
import AddPaymentReceivePage from "../pages/payment_receive/AddPaymentReceivePage";

function SubscriptionRoutes() {
  return (
    <>
      <Userlayout>
        <Routes>
          <Route
            path="customers"
            element={
              <PrivateRoute>
                <CustomersPage />
              </PrivateRoute>
            }
          ></Route>

          {/* customer page children routes */}
          <Route
            exact
            path="/customers/customer-details/:customer_id"
            element={
              <PrivateRoute>
                {" "}
                <CustomerDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/customers/add_customer"
            element={
              <PrivateRoute>
                {" "}
                <AddCustomerPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/dashboard"
            element={
              <PrivateRoute>
                {" "}
                <SubscriptionDashboard />{" "}
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/dashboard/customer-details/:customer_id"
            element={
              <PrivateRoute>
                {" "}
                <CustomerDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/products"
            element={
              <PrivateRoute>
                {" "}
                <ProductPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/grocedy-rating"
            element={
              <PrivateRoute>
                {" "}
                <RatingMainPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/grocedy-rating/details/:id"
            element={
              <PrivateRoute>
                {" "}
                <RatingDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          {/* Credit Notes */}
          <Route
            path="/credit-notes"
            element={
              <PrivateRoute>
                {" "}
                <CreditNoteMainPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/credit-notes/details/:id"
            element={
              <PrivateRoute>
                {" "}
                <CreditNoteDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/credit-notes/add-new"
            element={
              <PrivateRoute>
                {" "}
                <CreditNoteAddNew />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/corporate-approval"
            element={
              <PrivateRoute>
                {" "}
                <CorporateApprovalPage />{" "}
              </PrivateRoute>
            }
          ></Route>
          {/* <Route exact path='/corporate/add-new' element={
                  <PrivateRoute> <AddCorporatePage /> </PrivateRoute>}>
            </Route> */}
          <Route
            exact
            path="/corporate-approval/details/:corporate_id"
            element={
              <PrivateRoute>
                {" "}
                <CorporateAppDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          {/* Product feature */}
          <Route
            path="/product-category-feature"
            element={
              <PrivateRoute>
                {" "}
                <ProductFeaturePage />{" "}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/product-category-feature/add-new"
            element={
              <PrivateRoute>
                {" "}
                <AddProductFeature />{" "}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/product-category-feature/details/:id"
            element={
              <PrivateRoute>
                {" "}
                <ProductFeatureDetail />{" "}
              </PrivateRoute>
            }
          ></Route>

          {/* Product feature end */}

          <Route
            exact
            path="/corporate"
            element={
              <PrivateRoute>
                {" "}
                <CorporatePage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/corporate/add-new"
            element={
              <PrivateRoute>
                {" "}
                <AddCorporatePage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/corporate/details/:corporate_id"
            element={
              <PrivateRoute>
                {" "}
                <CorporateDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/customer-approval"
            element={
              <PrivateRoute>
                {" "}
                <CustomerApprovalPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/customer-approval/details/:customer_id"
            element={
              <PrivateRoute>
                {" "}
                <CustomerApproveDetails />{" "}
              </PrivateRoute>
            }
          ></Route>

          {/* product Page */}
          <Route
            exact
            path="/products/add-plan/:product_id"
            element={
              <PrivateRoute>
                {" "}
                <AddProductPlanPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/products/add-addon/:product_id"
            element={
              <PrivateRoute>
                {" "}
                <AddAddOnPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/products/edit-addon/:addon_id_edit/:product_id_edit"
            element={
              <PrivateRoute>
                {" "}
                <AddAddOnPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/products/add-coupon/:product_id"
            element={
              <PrivateRoute>
                {" "}
                <AddCouponPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/products/edit-coupon/:coupon_id_edit/:product_id_edit"
            element={
              <PrivateRoute>
                {" "}
                <AddCouponPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          {/* product Page end */}

          <Route
            exact
            path="/subscriptions"
            element={
              <PrivateRoute>
                {" "}
                <SubscriptionPage />{" "}
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/subscriptions/add-new"
            element={
              <PrivateRoute>
                {" "}
                <AddSubscriptionPage />{" "}
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/subscriptions/add-new"
            element={
              <PrivateRoute>
                {" "}
                <AddSubscriptionPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/subscriptions/details/:sub_id"
            element={
              <PrivateRoute>
                {" "}
                <SubscriptionDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/redeem-offline-voucher"
            element={
              <PrivateRoute>
                {" "}
                <VoucherOfflinePage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/redeem-offline-voucher/add-new"
            element={
              <PrivateRoute>
                {" "}
                <OfflineVoucherRedeem />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/redeem-offline-voucher/details/:id"
            element={
              <PrivateRoute>
                {" "}
                <OfflineDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          {/* Voucher Setup */}
          <Route
            path="/Setup"
            element={
              <PrivateRoute>
                {" "}
                <RewardCenterSetup />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/reward"
            element={
              <PrivateRoute>
                {" "}
                <RewardEarnPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/reward/details/:id"
            element={
              <PrivateRoute>
                {" "}
                <RewardHistoryDetails />{" "}
              </PrivateRoute>
            }
          ></Route>

          {/* Reward redeem */}
          <Route
            path="/carrier-bag-return"
            element={
              <PrivateRoute>
                {" "}
                <CarrierBagPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/carrier-bag-return/details/:id"
            element={
              <PrivateRoute>
                {" "}
                <CarrierDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/carrier-bag-return/add-new"
            element={
              <PrivateRoute>
                {" "}
                <CarrierBagAddNewPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route path="/reward-redeem" element={<PrivateRoute>
            <RewardRedeemPage />{" "}
          </PrivateRoute>
          }
          ></Route>

          <Route
            exact
            path="/invoices"
            element={
              <PrivateRoute>
                {" "}
                <InvoicePage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/invoices/details/:invoice_id"
            element={
              <PrivateRoute>
                {" "}
                <InvoiceDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/invoices/add-invoice"
            element={
              <PrivateRoute>
                {" "}
                <AddInvoicePage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/payment-received"
            element={
              <PrivateRoute>
                {" "}
                <PaymentReceivedPage />{" "}
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/payment-received/add-new"
            element={
              <PrivateRoute>
                {" "}
                <AddPaymentReceivePage />{" "}
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/payment-received/details/:payment_ref_id"
            element={
              <PrivateRoute>
                {" "}
                <PaymentReceivedDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/sales-order"
            element={
              <PrivateRoute>
                {" "}
                <SalesOrderPage />{" "}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/sales-order/add-new"
            element={
              <PrivateRoute>
                {" "}
                <AddSalesOrderPage />{" "}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/sales-order/details/:sales_id"
            element={
              <PrivateRoute>
                {" "}
                <SalesOrderDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            exact
            path="/corporate"
            element={
              <PrivateRoute>
                {" "}
                <CorporatePage />{" "}
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/corporate/add-new"
            element={
              <PrivateRoute>
                {" "}
                <AddCorporatePage />{" "}
              </PrivateRoute>
            }
          ></Route>
          <Route
            exact
            path="/corporate/details/:corporate_id"
            element={
              <PrivateRoute>
                {" "}
                <CorporateDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          {/* Corporate Voucher */}
          <Route
            path="/corporate-voucher"
            element={
              <PrivateRoute>
                {" "}
                <VoucherCorporateMainPage />{" "}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/corporate-voucher/add-new"
            element={
              <PrivateRoute>
                {" "}
                <AddCorporateVoucherPage />{" "}
              </PrivateRoute>
            }
          ></Route>
          <Route
            path="/corporate-voucher/details/:id"
            element={
              <PrivateRoute>
                {" "}
                <VoucherCorDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>
          {/* Corporate Voucher end */}

          <Route
            path="/voucher"
            element={   <PrivateRoute>  <VouchersMainPage />  </PrivateRoute>
            } ></Route>

          <Route path="/voucher/details/:id"
            element={ <PrivateRoute>   <VoucherDetailsPage /> </PrivateRoute> }
          ></Route>

          {/* Home page features */}
          <Route   path="/home-page-feature" element={
              <PrivateRoute>  <HomePageFeaturePage /> </PrivateRoute> } ></Route>

          <Route  path="/home-page-feature/add-new"
            element={  <PrivateRoute>  <AddHomePageFeature />  </PrivateRoute> } ></Route>

          <Route  path="/home-page-feature/details/:id"
            element={ <PrivateRoute>  <HomePageFeatureDetail />  </PrivateRoute>  } ></Route>
          {/* Home page feature end */}

          <Route  exact  path="/item-groups" element={ <PrivateRoute> <ItemGroupPage /> </PrivateRoute> }
          ></Route>

          <Route  path="/item-groups/add-item-group" element={
              <PrivateRoute>   <AddItemGroup />  </PrivateRoute> }
          ></Route>

          <Route
            path="/item-groups/item-group-details/:item_group_id"  element={
              <PrivateRoute>  <ItemGroupDetailsPage /> </PrivateRoute> }
          ></Route>

          {/*  item Routes */}

          <Route exact  path="/items"  element={ <PrivateRoute>
                <ItemPage />  </PrivateRoute> }  ></Route>

          <Route   path="/items/add-item/:option"   element={ <PrivateRoute> <AddItemPage /> </PrivateRoute>   }
          ></Route>

          <Route   path="/items/item-details/:item_id"
            element={ <PrivateRoute>  <ItemDetailsPage />  </PrivateRoute>  } ></Route>
          {/* Item Routes end */}

          {/* Price list routes */}

          <Route
            path="/price-list"
            element={
              <PrivateRoute>
                {" "}
                <PriceListPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/price-list/details/:id"
            element={
              <PrivateRoute>
                {" "}
                <PriceListDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>
          {/* Price list routes end */}

          {/* Credit score routes */}
          <Route
            path="/credit-score"
            element={
              <PrivateRoute>
                {" "}
                <CreditScoreMainPage />{" "}
              </PrivateRoute>
            }
          ></Route>

          <Route
            path="/credit-score/details/:id"
            element={
              <PrivateRoute>
                {" "}
                <CreditScoreDetailsPage />{" "}
              </PrivateRoute>
            }
          ></Route>
          {/* Credit score routes end */}

          <Route path="/*" element={<NotFoundPage />}></Route>
        </Routes>
      </Userlayout>
    </>
  );
}

export default SubscriptionRoutes;
